import { useEffect } from 'react';
import { message } from 'antd';
import { useBreakpoint } from 'utils/useBreakpoint';

export const useMessageConfig = () => {
  const { isLgDown } = useBreakpoint();

  useEffect(() => {
    if (isLgDown) {
      message.config({
        top: 70,
      });
    } else {
      message.config({
        getContainer: () => document.body,
        top: 8,
      });
    }
  }, [isLgDown]);
};
